import { EntityId } from "@reduxjs/toolkit";

import { IconButton } from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";

export interface DeviceListVisibilityToggleProps {
    deviceId?: EntityId;
    isSelected: boolean;
    onChange: (checked: boolean) => void;
}

export function DeviceListVisibilityToggle(
    props: DeviceListVisibilityToggleProps,
) {
    const icon = props.isSelected ? <VisibilityIcon /> : <VisibilityOffIcon />;

    return (
        <IconButton
            color={props.isSelected ? "primary" : "default"}
            onClick={() => props.onChange(!props.isSelected)}
        >
            {icon}
        </IconButton>
    );
}
